<p-tabView styleClass="fd_vr_tab_style" [(activeIndex)]="activeIndex" (onChange)="handleTabChange($event)">
    <p-tabPanel *ngFor="let item of formBuilderInfo?.fbPageFormTabs; let i = index" [selected]="i == activeIndex">
        <ng-template pTemplate="header">
            {{item?.tabName}}
        </ng-template>
        <div class="fd_content_style pb-3 pt-0" *ngIf="activeIndex === i">
            <ng-template [ngIf]="formBuilderTabInfo">
                <div class="row" *ngIf="showPageTitleSection && !isMultiStepForm">
                    <div class="col-12 px-0">
                        <app-fb-page-title-parent-action-button [pageFormType]="pageFormType"
                            [formBuilderInfo]="formBuilderTabInfo" [showSimpleForm]="showSimpleForm"
                            (pageFormButtonClicked)="onPageFormButtonClicked($event)"></app-fb-page-title-parent-action-button>
                    </div>
                </div>
                <div class="row" *ngIf="(showSimpleForm && simpleFormButton && formTypeSelected)">
                    <app-fb-simple-form [simpleFormButton]="simpleFormButton" [pageFormType]="pageFormType"
                        [formTypeSelected]="formTypeSelected" [isFBModulePreview]="isFBModulePreview"
                        [formBuilderInfo]="formBuilderTabInfo" (backToMasterList)="onBackToMasterList()" class="w-100"
                        [dataFormId]="formDataId"></app-fb-simple-form>
                </div>
                <div *ngIf="isMultiStepForm">
                    <app-fb-multi-step-form [steps]="steps" [onBackToMasterList]="onBackToMasterListReference" 
                    [simpleFormButton]="simpleFormButton" [btnClick]="buttonClicked" [dataFormId]="formDataId"></app-fb-multi-step-form>
                </div>
                <div class="row" *ngIf="pageFormType === 'master_listing_table' && !showSimpleForm && !isMultiStepForm">
                    <div class="col-12 px-0">
                        <app-master-list-table [formBuilderId]="item.pageFormId" [formBuilderInfo]="formBuilderTabInfo"
                            (actionTriggered)='handleAction($event)'></app-master-list-table>
                    </div>
                </div>
            </ng-template>
        </div>

    </p-tabPanel>
</p-tabView>
